import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export const propTypes = {};

export default function Subtitle({ children, ...rest }) {
  return (
    <Box mt={4} mb={1} {...rest}>
      <Typography variant="h2">{children}</Typography>
    </Box>
  );
}

Subtitle.propTypes = propTypes;
